module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMhCgoKTG9va2luZyBmb3J3YXJkIHRvIG1lZXRpbmcgeW91IGF0IENyb3NzbGluayAyMDE5IQ=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/dragon_complete.md
// module id = 1366
// module chunks = 0